(function() {
  var CART_DRAWER_ID = 'sidebar-cart';
  var CART_ACTION_SELECTOR = '[data-action="update-item-quantity"], [data-action="remove-item"]';
  var COLLECTION_ADD_FORM_SELECTOR = '[data-collection-add-to-cart-form]';
  var CART_INPUT_SELECTOR = '.QuantitySelector__CurrentQuantity';
  var FAQ_SUMMARY_LINK_SELECTOR = '.FaqPage__SummaryLink';
  var isUpdatingCart = false;

  function getCartDrawer() {
    return document.getElementById(CART_DRAWER_ID);
  }

  function closestElement(target, selector) {
    if (!target || target === document || target === window) {
      return null;
    }

    if (target.closest) {
      return target.closest(selector);
    }

    return target.parentElement ? target.parentElement.closest(selector) : null;
  }

  function getCartPageSection(target) {
    return target.closest('section[data-section-type="cart"]');
  }

  function getUpdateContext(target) {
    var drawer = getCartDrawer();

    if (drawer && drawer.contains(target)) {
      return {
        kind: 'drawer',
        root: drawer
      };
    }

    var pageSection = getCartPageSection(target);

    if (pageSection) {
      return {
        kind: 'page',
        root: pageSection
      };
    }

    return null;
  }

  function updateHeaderCartState(itemCount) {
    Array.prototype.forEach.call(document.querySelectorAll('.Header__CartDot'), function(dot) {
      dot.classList.toggle('is-visible', itemCount > 0);
    });

    Array.prototype.forEach.call(document.querySelectorAll('.Header__CartCount'), function(count) {
      count.textContent = itemCount;
    });
  }

  function beginCartUpdate(context) {
    isUpdatingCart = true;

    if (context && context.root) {
      context.root.setAttribute('aria-busy', 'true');
    }

    document.dispatchEvent(new CustomEvent('theme:loading:start'));
  }

  function endCartUpdate(context) {
    isUpdatingCart = false;

    if (context && context.root) {
      context.root.removeAttribute('aria-busy');
    }

    document.dispatchEvent(new CustomEvent('theme:loading:end'));
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function(response) {
      return response.json().catch(function() {
        return {};
      }).then(function(payload) {
        if (!response.ok) {
          throw new Error(payload.description || payload.message || 'Cart request failed');
        }

        return payload;
      });
    });
  }

  function fetchText(url, options) {
    return fetch(url, options).then(function(response) {
      if (!response.ok) {
        throw new Error('Cart markup request failed');
      }

      return response.text();
    });
  }

  function parseJsonNode(node) {
    if (!node) {
      return {};
    }

    try {
      return JSON.parse(node.textContent || '{}');
    } catch (error) {
      return {};
    }
  }

  function isVariantAvailableForStorefront(variant, availabilityMap) {
    if (!variant) {
      return false;
    }

    var variantId = String(variant.id);

    if (availabilityMap && Object.prototype.hasOwnProperty.call(availabilityMap, variantId)) {
      return availabilityMap[variantId] !== false;
    }

    if (variant.available === false) {
      return false;
    }

    var managesInventory = variant.inventory_management !== null && variant.inventory_management !== undefined && variant.inventory_management !== '';
    var inventoryQuantity = Number(variant.inventory_quantity);

    if (managesInventory && !isNaN(inventoryQuantity) && inventoryQuantity <= 0) {
      return false;
    }

    return true;
  }

  function getProductFormRoot(form) {
    return form.closest('[data-section-type="product"], [data-section-type="featured-product"], .product-page-container') || document;
  }

  function getProductDataForForm(form) {
    var root = getProductFormRoot(form);
    var customVariantData = root.querySelector('#variant-data');
    var productJson = root.querySelector('[data-product-json]');
    var parsedData = customVariantData ? {
      product: {
        variants: parseJsonNode(customVariantData)
      }
    } : parseJsonNode(productJson);

    var product = parsedData.product || {};

    return {
      availabilityMap: parsedData.storefront_availability || null,
      selectedVariantId: parsedData.selected_variant_id,
      variants: product.variants || []
    };
  }

  function getSelectedVariantId(form, data) {
    var checkedVariant = form.querySelector('[data-variant-id-control][type="radio"]:checked, input[name="id"][type="radio"]:checked');
    var variantSelect = form.querySelector('select[name="id"], [data-variant-id-control]:not([type="radio"])');
    var hiddenVariant = form.querySelector('input[name="id"]:not([type="radio"])');

    if (checkedVariant && checkedVariant.value) {
      return checkedVariant.value;
    }

    if (variantSelect && variantSelect.value) {
      return variantSelect.value;
    }

    if (hiddenVariant && hiddenVariant.value) {
      return hiddenVariant.value;
    }

    return data && data.selectedVariantId ? data.selectedVariantId : null;
  }

  function getSelectedVariantForForm(form) {
    var data = getProductDataForForm(form);
    var selectedVariantId = getSelectedVariantId(form, data);
    var selectedVariant = null;

    if (selectedVariantId) {
      selectedVariant = data.variants.find(function(variant) {
        return String(variant.id) === String(selectedVariantId);
      });
    }

    return {
      availabilityMap: data.availabilityMap,
      variant: selectedVariant
    };
  }

  function setProductFormAvailability(form, available, submitter) {
    var button = submitter || form.querySelector('.ProductForm__AddToCart, [data-add-to-cart-trigger]');
    var paymentButton = closestElement(form, COLLECTION_ADD_FORM_SELECTOR) ? null : getProductFormRoot(form).querySelector('.shopify-payment-button, .product-shopify-payment');

    if (button && available) {
      button.setAttribute('data-storefront-available', 'true');

      if (button.getAttribute('data-storefront-blocked') === 'true') {
        button.removeAttribute('disabled');
        button.setAttribute('data-action', 'add-to-cart');
        button.classList.remove('Button--secondary');
        button.classList.add('Button--primary');

        if (button.dataset.storefrontEnabledHtml) {
          button.innerHTML = button.dataset.storefrontEnabledHtml;
        } else if (window.languages && window.languages.productFormAddToCart) {
          button.innerHTML = window.languages.productFormAddToCart;
        }

        button.removeAttribute('data-storefront-blocked');
      }
    }

    if (button && !available) {
      if (button.getAttribute('data-storefront-blocked') !== 'true' && !button.hasAttribute('disabled')) {
        button.dataset.storefrontEnabledHtml = button.innerHTML;
      }

      button.setAttribute('disabled', 'disabled');
      button.removeAttribute('data-action');
      button.setAttribute('data-storefront-available', 'false');
      button.setAttribute('data-storefront-blocked', 'true');
      button.classList.remove('Button--primary');
      button.classList.add('Button--secondary');
      button.innerHTML = window.languages && window.languages.productFormSoldOut ? window.languages.productFormSoldOut : 'Sold out';
    }

    if (paymentButton) {
      paymentButton.style.display = available ? '' : 'none';
    }
  }

  function isMarkedUnavailable(form, submitter) {
    return form.getAttribute('data-storefront-available') === 'false' ||
      submitter && submitter.getAttribute('data-storefront-available') === 'false';
  }

  function shouldBlockStorefrontSubmit(form, submitter) {
    if (isMarkedUnavailable(form, submitter)) {
      setProductFormAvailability(form, false, submitter);
      return true;
    }

    var selected = getSelectedVariantForForm(form);

    if (!selected.variant) {
      return false;
    }

    if (!isVariantAvailableForStorefront(selected.variant, selected.availabilityMap)) {
      setProductFormAvailability(form, false, submitter);
      return true;
    }

    setProductFormAvailability(form, true, submitter);
    return false;
  }

  function syncRenderedProductForms() {
    Array.prototype.forEach.call(document.querySelectorAll('form.ProductForm'), function(form) {
      var selected = getSelectedVariantForForm(form);
      var button = form.querySelector('.ProductForm__AddToCart, [data-add-to-cart-trigger]');

      if (button && button.getAttribute('data-storefront-available') === 'false') {
        setProductFormAvailability(form, false, button);
        return;
      }

      if (selected.variant) {
        setProductFormAvailability(form, isVariantAvailableForStorefront(selected.variant, selected.availabilityMap), button);
      }
    });
  }

  function buildCartUrl(extraParams) {
    var url = new URL(window.routes.cartUrl, window.location.origin);
    var currentParams = new URLSearchParams(window.location.search);

    currentParams.forEach(function(value, key) {
      if (key === '_fd' || key === 'pb' || key === 'key' || key.indexOf('preview_') === 0) {
        url.searchParams.set(key, value);
      }
    });

    if (extraParams) {
      Object.keys(extraParams).forEach(function(key) {
        if (extraParams[key] !== null && extraParams[key] !== undefined) {
          url.searchParams.set(key, extraParams[key]);
        }
      });
    }

    return url.toString();
  }

  function fetchCurrentCart() {
    return fetchJson(window.routes.cartUrl + '.js', {
      credentials: 'same-origin',
      method: 'GET'
    });
  }

  function fetchMiniCartMarkup() {
    return fetchText(buildCartUrl({
      section_id: 'mini-cart',
      timestamp: Date.now()
    }), {
      credentials: 'same-origin',
      method: 'GET'
    });
  }

  function fetchMainCartMarkup() {
    return fetchText(buildCartUrl({
      timestamp: Date.now()
    }), {
      credentials: 'same-origin',
      method: 'GET'
    });
  }

  function replaceMiniCart(markup) {
    var drawer = getCartDrawer();

    if (!drawer) {
      return;
    }

    var container = document.createElement('div');
    container.innerHTML = markup;

    var nextCart = container.querySelector('.Cart');
    var currentCart = drawer.querySelector('.Cart');

    if (!nextCart || !currentCart || !currentCart.parentNode) {
      return;
    }

    var currentMain = currentCart.querySelector('.Drawer__Main');
    var scrollTop = currentMain ? currentMain.scrollTop : 0;

    currentCart.parentNode.replaceChild(nextCart, currentCart);

    var nextMain = drawer.querySelector('.Drawer__Main');
    if (nextMain) {
      nextMain.scrollTop = scrollTop;
    }

    var settingsNode = container.querySelector('[data-section-type="cart"]');
    if (!settingsNode) {
      return;
    }

    try {
      var settings = JSON.parse(settingsNode.getAttribute('data-section-settings') || '{}');
      updateHeaderCartState(settings.itemCount || 0);
    } catch (error) {
    }
  }

  function swapSectionNode(currentSection, nextSection, selector) {
    var currentNode = currentSection.querySelector(selector);
    var nextNode = nextSection.querySelector(selector);

    if (currentNode && nextNode) {
      currentNode.parentNode.replaceChild(nextNode, currentNode);
      return;
    }

    if (currentNode && !nextNode) {
      currentNode.parentNode.removeChild(currentNode);
      return;
    }

    if (!currentNode && nextNode && selector === '.DynamicCart__Highlight') {
      var header = currentSection.querySelector('.DynamicCart__Header');

      if (header && header.parentNode) {
        header.insertAdjacentElement('afterend', nextNode);
      }
    }
  }

  function replaceMainCart(markup, context) {
    var currentSection = context.root;

    if (!currentSection) {
      return;
    }

    var container = document.createElement('div');
    container.innerHTML = markup;

    var nextSection = container.querySelector('section[data-section-type="cart"]');

    if (!nextSection) {
      return;
    }

    var nextSettings = nextSection.getAttribute('data-section-settings');
    if (nextSettings) {
      currentSection.setAttribute('data-section-settings', nextSettings);
    }

    if (nextSection.querySelector('.EmptyState') || !nextSection.querySelector('.DynamicCart')) {
      currentSection.innerHTML = nextSection.innerHTML;
      return;
    }

    swapSectionNode(currentSection, nextSection, '.DynamicCart__Header');
    swapSectionNode(currentSection, nextSection, '.DynamicCart__Highlight');
    swapSectionNode(currentSection, nextSection, '.DynamicCart__ItemsCard');
    swapSectionNode(currentSection, nextSection, '.DynamicCart__SummaryCard');
  }

  function getRequestedQuantity(target) {
    if (target.classList.contains('QuantitySelector__CurrentQuantity')) {
      var typedQuantity = parseInt(target.value, 10);
      return Math.max(isNaN(typedQuantity) ? 1 : typedQuantity, 1);
    }

    if (target.getAttribute('data-action') === 'remove-item') {
      return 0;
    }

    var quantity = parseInt(target.getAttribute('data-quantity'), 10);
    return isNaN(quantity) ? null : Math.max(quantity, 0);
  }

  function resolveCartItem(target, cart) {
    var itemKey = target.getAttribute('data-item-key');
    var index;

    if (itemKey) {
      for (index = 0; index < cart.items.length; index += 1) {
        if (cart.items[index].key === itemKey) {
          return cart.items[index];
        }
      }
    }

    var line = parseInt(target.getAttribute('data-line'), 10);

    if (!isNaN(line) && line > 0 && cart.items[line - 1]) {
      return cart.items[line - 1];
    }

    return null;
  }

  function syncCartUi(context, updatedCart) {
    updateHeaderCartState(updatedCart.item_count || 0);

    if (context.kind === 'drawer') {
      return fetchMiniCartMarkup().then(function(markup) {
        replaceMiniCart(markup);
      });
    }

    return fetchMainCartMarkup().then(function(markup) {
      replaceMainCart(markup, context);
    });
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    var trigger = document.querySelector('[data-action="open-drawer"][data-drawer-id="' + CART_DRAWER_ID + '"]');

    if (trigger) {
      trigger.click();
      return;
    }

    if (!drawer) {
      return;
    }

    drawer.setAttribute('aria-hidden', 'false');
    drawer.setAttribute('data-visible', 'true');
    drawer.style.maxHeight = window.innerHeight + 'px';
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('drawer-open--cart');
    document.documentElement.dispatchEvent(new CustomEvent('drawer:open', {
      detail: {
        drawerId: CART_DRAWER_ID,
        drawer: drawer
      }
    }));
  }

  function handleCollectionAddToCart(form, submitter) {
    if (shouldBlockStorefrontSubmit(form, submitter)) {
      return Promise.resolve();
    }

    var formData = new FormData(form);
    var context = {
      kind: 'drawer',
      root: getCartDrawer() || form
    };

    if (submitter) {
      submitter.setAttribute('aria-busy', 'true');
      submitter.disabled = true;
    }

    beginCartUpdate(context);

    return fetchJson(window.routes.cartAddUrl + '.js', {
      body: formData,
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function() {
      return fetchCurrentCart();
    }).then(function(cart) {
      updateHeaderCartState(cart.item_count || 0);
      return fetchMiniCartMarkup();
    }).then(function(markup) {
      replaceMiniCart(markup);
      openCartDrawer();
    }).catch(function(error) {
      window.location.href = form.getAttribute('action') || window.routes.cartUrl;
      throw error;
    }).then(function() {
      if (submitter) {
        submitter.removeAttribute('aria-busy');
        submitter.disabled = false;
      }
      endCartUpdate(context);
    }, function() {
      if (submitter) {
        submitter.removeAttribute('aria-busy');
        submitter.disabled = false;
      }
      endCartUpdate(context);
    });
  }

  function recoverCartUi(context) {
    if (context.kind === 'drawer') {
      return fetchMiniCartMarkup().then(function(markup) {
        replaceMiniCart(markup);
      }).catch(function() {
      });
    }

    return fetchMainCartMarkup().then(function(markup) {
      replaceMainCart(markup, context);
    }).catch(function() {
      window.location.href = buildCartUrl();
    });
  }

  function changeCartQuantity(target, context) {
    var quantity = getRequestedQuantity(target);

    if (quantity === null) {
      return Promise.resolve();
    }

    beginCartUpdate(context);

    return fetchCurrentCart().then(function(cart) {
      var item = resolveCartItem(target, cart);

      if (!item) {
        throw new Error('Cart item no longer exists');
      }

      return fetchJson(window.routes.cartChangeUrl + '.js', {
        body: JSON.stringify({
          id: item.key,
          quantity: quantity
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
    }).then(function(updatedCart) {
      return syncCartUi(context, updatedCart);
    }).catch(function() {
      return recoverCartUi(context);
    }).then(function() {
      endCartUpdate(context);
    }, function() {
      endCartUpdate(context);
    });
  }

  function activateFaqSummaryLink(link) {
    var summary = closestElement(link, '.FaqPage__Summary');

    if (!summary) {
      return;
    }

    Array.prototype.forEach.call(summary.querySelectorAll(FAQ_SUMMARY_LINK_SELECTOR), function(summaryLink) {
      summaryLink.classList.toggle('is-active', summaryLink === link);
    });
  }

  function scrollToFaqSection(link) {
    var selector = link.getAttribute('href');

    if (!selector || selector.charAt(0) !== '#') {
      return false;
    }

    var anchor = document.querySelector(selector);

    if (!anchor) {
      return false;
    }

    var section = anchor.closest ? anchor.closest('.Faq__Section') : null;
    section = section || anchor;
    var header = document.getElementById('shopify-section-header');
    var offset = header ? header.getBoundingClientRect().height + 18 : 80;
    var targetTop = section.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      behavior: 'smooth',
      top: Math.max(targetTop, 0)
    });

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search + selector);
    }

    activateFaqSummaryLink(link);
    return true;
  }

  document.addEventListener('click', function(event) {
    var trigger = closestElement(event.target, CART_ACTION_SELECTOR);
    var context = trigger ? getUpdateContext(trigger) : null;

    if (!trigger || !context) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (isUpdatingCart) {
      return;
    }

    changeCartQuantity(trigger, context);
  }, true);

  document.addEventListener('click', function(event) {
    var submitter = closestElement(event.target, '.ProductForm__AddToCart, [data-add-to-cart-trigger]');
    var form = submitter ? closestElement(submitter, 'form') : null;

    if (!form || closestElement(form, COLLECTION_ADD_FORM_SELECTOR)) {
      return;
    }

    if (!shouldBlockStorefrontSubmit(form, submitter)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function(event) {
    var link = closestElement(event.target, FAQ_SUMMARY_LINK_SELECTOR);

    if (!link) {
      return;
    }

    if (!scrollToFaqSection(link)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('click', function(event) {
    var submitter = closestElement(event.target, COLLECTION_ADD_FORM_SELECTOR + ' [type="submit"]');
    var form = submitter ? closestElement(submitter, COLLECTION_ADD_FORM_SELECTOR) : null;

    if (form && shouldBlockStorefrontSubmit(form, submitter)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (!form || !window.routes || !window.routes.cartAddUrl || submitter.disabled) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (isUpdatingCart) {
      return;
    }

    handleCollectionAddToCart(form, submitter);
  }, true);

  document.addEventListener('submit', function(event) {
    var form = closestElement(event.target, COLLECTION_ADD_FORM_SELECTOR);

    if (form && shouldBlockStorefrontSubmit(form, event.submitter || form.querySelector('[type="submit"]'))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (!form || !window.routes || !window.routes.cartAddUrl) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (isUpdatingCart) {
      return;
    }

    handleCollectionAddToCart(form, event.submitter || form.querySelector('[type="submit"]'));
  }, true);

  document.addEventListener('submit', function(event) {
    var form = closestElement(event.target, 'form.ProductForm');
    var submitter = event.submitter || form && form.querySelector('.ProductForm__AddToCart, [data-add-to-cart-trigger]');

    if (!form || closestElement(form, COLLECTION_ADD_FORM_SELECTOR)) {
      return;
    }

    if (!shouldBlockStorefrontSubmit(form, submitter)) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);

  document.addEventListener('variant:changed', function(event) {
    var root = event.target && event.target.closest ? event.target.closest('[data-section-type="product"], [data-section-type="featured-product"]') : null;
    var form = root ? root.querySelector('form.ProductForm') : null;

    if (!form) {
      return;
    }

    var selected = getSelectedVariantForForm(form);
    var variant = event.detail && event.detail.variant ? event.detail.variant : selected.variant;
    setProductFormAvailability(form, isVariantAvailableForStorefront(variant, selected.availabilityMap), form.querySelector('.ProductForm__AddToCart'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncRenderedProductForms);
  } else {
    syncRenderedProductForms();
  }

  document.addEventListener('change', function(event) {
    var input = closestElement(event.target, CART_INPUT_SELECTOR);
    var context = input ? getUpdateContext(input) : null;

    if (!input || !context) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (isUpdatingCart) {
      return;
    }

    changeCartQuantity(input, context);
  }, true);
})();
